<template>
  <div class="pay-container">
    <van-nav-bar :title="$route.meta.title">
      <template #left>
        <van-icon @click="back" name="arrow-left" color="#46474B" size="20px" />
      </template>
    </van-nav-bar>
    <div class="pay-success text-align-center">
      <img src="@/assets/pay-state/pay-success.png" alt="">
      <p>支付成功</p>
      <!-- 1、一对一咨询（4：图文付费资讯） 2、案件委托5-->
      <!-- <div v-if="Number($route.query.caseSourceType) === 4" class="auto-box"> -->
      <div v-if="!showData.showBtn" class="auto-box">
        <p class="auto-jump">
          {{ second }}s后自动{{ showData.msg }}
        </p>
      </div>
      <!-- 1、公共咨询（3快速咨询（极速咨询）2、电话咨询6） -->
      <button v-else @click="jump">
        <!-- 进行咨询 -->
        {{ showData.msg }}
      </button>
    </div>
  </div>
</template>

<script>
/**
 * 支付成功 只展示按钮 或者 倒计时操作（任意一个）
 * caseSourceType
  3: 快速咨询（极速咨询）     去咨询助手页面
  4：图文付费资讯（一对一）    去一对一聊天会话页面
  5：案件委托案源             去我的订单页面  payCaseType=CASE_ENTRUSTMENT（在订单页面 会有toast提醒）
  6：电话咨询案源             去我的咨询电话咨询页面
 */
import { buriedChannelPoint } from '@/api/common'
import { POINT_CODE, BURY_POINT_TYPE, BEHAVIOR } from '@/libs/config'
import { callApp } from "@/libs/bridge";
import { NavBar,Icon } from 'vant';

export default {
  components: {
    'van-icon': Icon,
    'van-nav-bar': NavBar
  },
  data(){
    return{
      second: 3
    }
  },
  computed: {
    showData(){
      let data = { showBtn: true, msg: '进行咨询' }
      switch(Number(this.$route.query.caseSourceType)){
      case 3:
        data = { showBtn: true, msg: '进行咨询' }
        break
      case 4:
        data = { showBtn: false, msg: '开始咨询', path: `/lawyer-im/appoint-consulting-assistant-im-chatroom/${this.$route.query.lawyerId}?conversationId=${this.$route.query.imSessionId}&caseSourceId=${this.$route.query.sourceId}` }
        break
      case 8:
        data = { showBtn: false, msg: '开始咨询', path: `/lawyer-im/appoint-consulting-assistant-im-chatroom/${this.$route.query.lawyerId}?conversationId=${this.$route.query.imSessionId}&caseSourceId=${this.$route.query.sourceId}` }
        break
      case 5:
        data = { showBtn: false, msg: '跳转', path: '/myorder?payCaseType=CASE_ENTRUSTMENT'}
        break
      case 6:
        data = { showBtn: true, msg: '查看咨询进度', path: '/my-consultation?active=2',buryPointPageCode:POINT_CODE.DHZX_ZFCGY_CKJD }
        break
      default:
        break
      }
      return data
    }
  },
  mounted() {
    window.physicsBackFn = this.back
    !this.showData.showBtn && this.autoJump()
    // 3:公共付费案源，4.一对一付图文费案源，5.案件委托案源，6.电话咨询案源，8.一对一电话咨询案源
    if(this.$route.query.caseSourceType==='4'){
      this.buryPointPage(POINT_CODE['1V1_TWZX_ZFCG_PAGE'],BEHAVIOR.VI)
    }else if(this.$route.query.caseSourceType==='8'){
      this.buryPointPage(POINT_CODE['1V1_DHZX_ZFCG_PAGE'],BEHAVIOR.VI)
    }else if(this.$route.query.caseSourceType==='6'){
      this.buryPointPage(POINT_CODE.DHZX_DHZX_ZFCGTC,BEHAVIOR.VI)
    }
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: { 
    buryPointPage(code,behavior){
      let params = {
        code: code,
        type: BURY_POINT_TYPE.PAGE,
        behavior: behavior,
      }
      buriedChannelPoint(params)
    },
    back(){
      callApp('finishActivity')
    },
    // 成功
    jump(){
      // 页面埋点
      this.showData.buryPointPageCode && this.buryPointPage(this.showData.buryPointPageCode,BEHAVIOR.CK)
      callApp('finishActivity')
      // this.$router.push(this.showData.path)
    },
    autoJump(){
      this.timer = setInterval(() => {
        this.second--
        if(this.second === 0){ 
          callApp('finishActivity')
          // this.$router.push(this.showData.path)
        }
      }, 1000)
    }
  }
}
</script>

<style scoped lang="scss">
.pay-container{
  min-height: 100vh;
  background: white;
}
.pay-success{
  font-size: 0;
  p{
    padding: 29px 0 48px;
    font-size: 18px;
    color: #333333;
    font-weight: 600;
  }
  .auto-box{
    width: 100%;
    display: flex;
    justify-content: center;
    .auto-jump{
      width: 142px;
      height: 40px;
      border-radius: 20px;
      border: 1px solid #ECECEC;
      color: #333;
      font-size: 14px;
      padding: 0;
      text-align: center;
      line-height: 40px;
      align-self: center;
    }
  }
  img{
    padding-top: 48px;
    // width: 105px;
    // height: 115px;
    width: 121px;
    height: 120px;
  }
  button{
    // width: 343px;
    width: 142px;
    height: 40px;
    background: #FFA700;
    border-radius: 20px;
    font-size: 15px;
    font-weight: 600;
    color: #FFFFFF;
    border: none;
  }
}
</style>
